import dJSON from 'dirty-json';

/**
 * Carousel Tabs Init
 */

(() => {
  if (!document.querySelector('.module-carousel-tabs')) return;

  // get title slide data
  const titleData = document.querySelector('.module-carousel-tabs').data;
  const data = dJSON.parse(titleData);

  // get titles from carousels and create tabs
  const merchTitles = [];
  const tabImages = [];
  document.querySelectorAll('.container:not(.mobile) .carousel-tab').forEach((carousel, i) => {
    // get titles from carousel widgets
    merchTitles.push(carousel.querySelector(':scope > h3').textContent);
    // get images from data
    const bg = data[i].background || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-tabs-bg.jpg';
    tabImages.push(bg);
  });

  // create tab titles
  document.querySelectorAll('.module-carousel-tabs').forEach((item) => {
    let arr = '';
    merchTitles.forEach((entry, i) => {
      const icon = data[i].icon || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-icon-pencil.svg';
      arr += `<div class="tab-title" tab-id="${i}" tabindex="0"><img src="${icon}" />${entry}</div>`;
    });
    item.querySelector('.js-tabs').innerHTML = arr;
  });

  // create tab background images
  const tabImageWrapper = document.createElement('div');
  let imgArr = '';
  tabImageWrapper.className = 'tab-images js-tab-images';
  tabImages.forEach((entry, i) => {
    imgArr += `<img src="${entry}" tab-id="${i}">`;
  });
  tabImageWrapper.innerHTML = imgArr;
  document.querySelector('.module-carousel-tabs').prepend(tabImageWrapper);

  // add tab / slide content
  document.querySelectorAll('.container:not(.mobile) .carousel-tab').forEach((carousel, i) => {
    // tab wrapper
    const tabContent = document.createElement('div');
    tabContent.className = 'js-tab';
    tabContent.setAttribute('tab-id', i);

    // title block
    const slideTitleBlock = document.createElement('div');
    slideTitleBlock.className = 'slide-title-block';

    const title = data[i].title || 'Get all of the amazing products you need!';
    const text = data[i].text || '';
    const url = data[i].url || '';

    slideTitleBlock.innerHTML = /* html */ `
    <h2 class="text-white">${title}</h2>
    <p class="text-white">${text}</p>
    <p><a class="nButton nbBlack" href="${url}">Find Out More</a></p>
    `;

    // carousel
    const slider = document.createElement('div');
    slider.className = 'js-carousel-slider carousel-slider';

    carousel.querySelectorAll('.tile').forEach((tile) => {
      slider.append(tile);
    });

    tabContent.append(slideTitleBlock);
    tabContent.append(slider);
    document.querySelectorAll('.module-carousel-tabs').forEach((item) => {
      item.querySelector('.js-tabbed-content').append(tabContent);
    });
  });
})();
